<template>
  <div class="card">
    <div class="card-body">
      <h3>Upload Media</h3>
      <div class="form-group">
        <div class="row">
          <div class="col-md-12">
            <div class="custom-file">
              <input
                type="file"
                class="custom-file-input"
                @change="onFileSelected"
                :disabled="disabled"
                accept="image/*"
              />
              <label class="custom-file-label">Choose file</label>
            </div>
            <div class="py-2" v-if="fileName">
              <div class="badge badge-primary">{{ fileName }}</div>
            </div>
            <div class="my-3" v-if="vendors.media.uploading">
              <div class="progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  :style="`width: ` + vendors.media.progress + `%`"
                >
                  {{ progressPercent }}
                </div>
              </div>
            </div>
            <alert v-if="vendors.media.loading" type="loader" class="my-3" />
            <div class="row mt-3">
              <div v-for="m in vendors.media.data" :key="m.id" class="col-2">
                <img
                  :src="m.thumb"
                  class="w-100 rounded cursor-pointer"
                  @click="enlargeImage(m)"
                />
                <button
                  @click="!disabled && deleteMedia(m)"
                  :disabled="disabled"
                  class="mt-2 btn btn-sm btn-block btn-outline-danger"
                >
                  <icon v-if="m.state != 'DELETING'" type="trash"></icon>
                  <spinner v-if="m.state == 'DELETING'" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";
export default {
  name: "UploadMedia",
  props: ["disabled"],
  computed: {
    ...mapState(["vendors"]),
    selectedFile: function () {
      return this.vendors.media.file;
    },
    media: function () {
      return this.vendors.media.data;
    },
    fileName: function () {
      if (this.selectedFile) {
        return this.selectedFile.name;
      }
      return false;
    },
    progressPercent: function () {
      if (typeof this.vendors.media.progress === "number") {
        if (this.vendors.media.progress < 100) {
          return this.vendors.media.progress + "%";
        } else {
          return "Processing Image.... ";
        }
      }
      return this.vendors.media.progress;
    },
  },

  mounted() {
    this.$store.dispatch("vendors/getMedia", this.$route.params.id);
  },
  methods: {
    enlargeImage: function (img) {
      Swal.fire({
        imageUrl: img.url,
        allowOutsideClick: true,
        allowEscapeKey: true,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    isImage: function (file) {
      if (file) {
        return file["type"].split("/")[0] === "image";
      }
    },
    onFileSelected: function (event) {
      var file = event.target.files[0];
      if (this.isImage(file)) {
        this.$store.dispatch("vendors/uploadMedia", {
          vendor: this.vendors.single,
          file: file,
        });
      }
    },
    deleteMedia: function (media) {
      media.state = "DELETING";
      this.$store.dispatch("vendors/deleteMedia", {
        mid: media.id,
        id: this.vendors.single.id,
      });
    },
  },
};
</script>
